export default __webpack_public_path__ + "static/media/fa-regular-400.6e0ccd0d.svg";